import { useState, useEffect } from 'react';
import { ProgressIndicatorCircular } from '@andes/progress-indicator-circular';
import { Modal } from '@andes/modal';
import classNames from 'classnames';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
var _div;
var IFRAME_ID = 'iframe-add-to-cart';
var namespace = 'ui-ms-iframe-modal';
var ModalAddToCart = function ModalAddToCart(_ref) {
  var id = _ref.id,
    title = _ref.title,
    deviceType = _ref.deviceType,
    src = _ref.src,
    show = _ref.show,
    onCloseModal = _ref.onCloseModal;
  var indicatorSize = deviceType === 'mobile' ? 'medium' : 'large';
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showProgress = _useState2[0],
    setShowProgress = _useState2[1];
  var typeModal = deviceType === 'mobile' ? 'card' : 'large';
  var modalClassName = classNames(namespace, _defineProperty(_defineProperty({}, "".concat(namespace, "--desktop"), typeModal === 'large'), "".concat(namespace, "--mobile"), typeModal !== 'large'));
  useEffect(function () {
    function handleMessage(e) {
      var _e$data;
      if (e.data && ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.type) === 'vpp:on-demand-iframe:resize') {
        document.getElementById(IFRAME_ID).style.height = e.data.height + 'px';
      }
    }
    window.addEventListener('message', handleMessage);
    return function () {
      window.removeEventListener('message', handleMessage);
    };
  });
  return /*#__PURE__*/_createRawReactElement(Modal, {
    open: show,
    id: id,
    onClose: onCloseModal,
    type: typeModal,
    title: title,
    className: modalClassName,
    media: {
      asset: _div || (_div = /*#__PURE__*/_createRawReactElement("div", {}))
    }
  }, void 0, showProgress && /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__progress-indicator-container")
  }, void 0, /*#__PURE__*/_createRawReactElement(ProgressIndicatorCircular, {
    size: indicatorSize
  })), /*#__PURE__*/_createRawReactElement("iframe", {
    id: IFRAME_ID,
    title: "iframe",
    src: src,
    onLoad: function onLoad() {
      return setShowProgress(false);
    },
    "data-testid": "iframe-add-to-cart"
  }));
};
ModalAddToCart.defaultProps = {
  id: '',
  title: '',
  deviceType: 'mobile',
  src: '',
  onCloseModal: function onCloseModal() {}
};
var ModalAddToCart$1 = ModalAddToCart;
export { ModalAddToCart$1 as ModalAddToCart, ModalAddToCart$1 as default };
